import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/Header";
import { BottomNav } from "@/components/BottomNav";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — PataTasks" },
      {
        name: "description",
        content: "Privacy policy for PataTasks app and web testing platform.",
      },
    ],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  const paragraphs = [
    "We respect your privacy. PataTasks is a modern app and web testing platform. We collect only the information necessary to provide our services to testers and third-party providers.",
    "Account data such as email, name, and test activity is stored securely. We do not sell or share your personal information with third parties except as required by law or payment processing.",
    "Payment processing is handled by IntaSend. We do not store full card or M-Pesa details on our servers.",
    "You may request account deletion at any time from the Profile page.",
  ];

  return (
    <div className="bg-background pb-20 md:pb-0">
      <div className="mx-auto max-w-3xl px-4 py-10">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-foreground mb-4 sm:mb-6">
          Privacy Policy
        </h1>
        <div className="space-y-4 sm:space-y-6">
          {paragraphs.map((text, idx) => (
            <p
              key={idx}
              className="rounded-xl border border-blue-200 bg-white p-4 sm:p-5 shadow-sm text-base leading-relaxed text-slate-700"
            >
              {text}
            </p>
          ))}
        </div>
      </div>
      <BottomNav />
    </div>
  );
}
